module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("An Introduction to the Scriptures of Israel: History and Theology")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "pre1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "abb1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/abbreviations#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "c1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch01"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Three Introductions")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "c2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ch02"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Wisdom Tradition: Religion without Revelation")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "c3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Revelation and Love: The Patriarchal Narratives and the Song of Songs")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "c4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Joseph and Narrative")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "c5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Exodus: Freedom and Sonship")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "c6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Sinai: Covenant and Code")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "c7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Problem of Monarchy: Samuel and Kings")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "c8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Condemning Israel, Sparing the Nations: Amos and Jonah")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "c9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Eden and the Art of Reading")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "c10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Priestly Theology and Holy Space")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "c11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Exile and Return: Prophetic Visions")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "c12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Consolidation of Judaism: Temple and Torah")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "c13"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter013#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Violence and Identity: Joshua and Judges")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "c14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Jews, Gentiles, and Gender: Esther, Ruth, Ezra, and Nehemiah")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "c15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter015#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Apocalyptic: Daniel and the Dead Sea Scrolls")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "c16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter016#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Israelite at Prayer: The Book of Psalms")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ind1_1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001#ind1-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Subject Index")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ind1_2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index002#ind1-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture and Other Ancient Sources Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0